import React from "react";

const FLATDashboard = () => <div>FLAT Dashboard - under construction</div>;

export default FLATDashboard;